export const localStorageSet = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    console.debug("catched ns localstorage firefox fault");
  }
};

export const localStorageGet = (key, defaultVal) => {
  try {
    const val = localStorage.getItem(key);
    return val ? val : defaultVal;
  } catch (e) {
    console.debug("catched ns localstorage firefox fault");
    return defaultVal;
  }
};
